<template>
  <div class="gallery full">
      <div class="choosetitle" style="font-size: 3vw;margin:0;letter-spacing: 20px;margin-top: 5%;">GALLERY</div>

    <div class="gallcontent">
    <div  style="margin-bottom: 15%;" @click="startpop('Exterior')" > 
      <img :src="GLOBAL.imgserve+'/gallery/exterior.png'" alt="">
    </div>

    <div style="background: aliceblue;height: 70%;width: 2px;"></div>

    <div style="margin-top: 15%;" @click="startpop('Interior')">
      <img :src="GLOBAL.imgserve+'/gallery/interior.png'" alt="">
    </div>

    <div style="background: aliceblue;height: 70%;width: 2px;"></div>

    <div style="margin-bottom: 15%;" @click="startpop('Animation')">
      <img :src="GLOBAL.imgserve+'/gallery/animation.png'" alt="">
      </div>
    </div>
    <div class="gallpop" v-show="gallpop">
      <div class="back btn"  @click="endpop()"><img  :src="GLOBAL.imgserve+'/btn/X.png'" alt=""></div>
      <div class="full">
      <video id="videodiv" loop style="width: 100%;height: 100%;" autoplay controls="controls" v-if="nowdataname == 'Animation'" :src="GLOBAL.imgserve+'/gallery/video.mp4'"></video>
      <swiper v-else
            :options="swiperOption"
      >
            <!-- 视频 -->
              <!-- <swiper-slide v-if="nowdataname == 'Animation'">video</swiper-slide> -->

            <!-- 图片 -->
              <swiper-slide  v-for="(item, index) in nowdata" :key="index">
                <img ondragstart="return false;" style="min-height: 100%;" :src="GLOBAL.imgserve+item" alt="">
              </swiper-slide>
    
              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              <div class="swiper-button-prev" slot="button-prev">
                <!-- <img :src="GLOBAL.imgserve+'/btn/X.png'" alt=""> -->
              </div>
              <div class="swiper-button-next" slot="button-next">
                <!-- <img :src="GLOBAL.imgserve+'/btn/X.png'" alt=""> -->
              </div>
      </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gallpop:false,
      nowdata:[],
      nowdataname:'',
      gallerydata:{
        "Exterior":[
          '/gallery/Exterior/106-PPH-v1.jpg',
          '/gallery/Exterior/106-PPH-v2.jpg',
          '/gallery/Exterior/106-PPH-v3.jpg',
          '/gallery/Exterior/106-PPH-v4.jpg',
          '/gallery/Exterior/106-PPH-v5.jpg',
          '/gallery/Exterior/106-PPH-v6.jpg',],
        "Interior":[
          '/gallery/Interior/106-PPH-v1.jpg',
          '/gallery/Interior/106-PPH-v2.jpg',
          '/gallery/Interior/106-PPH-v3.jpg',
          '/gallery/Interior/106-PPH-v4.jpg',
          '/gallery/Interior/106-PPH-v5.jpg',],
        "Animation":['/home.png','/home.png','/home.png','/home.png','/home.png'],
      },
      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // 设置自动轮播
        autoplay: {
          delay: 5000 // 5秒切换一次
        },
        // 设置轮播可循环
        loop: true
      }
    }
    
  },
  methods:{
    startpop(vl){
      this.nowdata = this.gallerydata[vl]
      this.nowdataname = vl
      console.log(vl);
      this.gallpop = true

    },
    endpop(){
      if(this.nowdataname == 'Animation'){
      var ele = document.getElementById('videodiv')
      ele.pause()

      }
      this.gallpop = false
    }
  }
}
</script>

<style >
.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after,
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after{
  /* content: 'none'; */
  font-size: 3rem;
  color: white;
}
.swiper-button-prev, .swiper-button-next{
  width:auto;
}

.swiper-container{
      width: 100%;
    height: 100%;
}
.swiper-slide{
        width: 100%;
    height: 100%;
}


.gallery{
  flex-flow: column;
}
.gallcontent{
  width: 80%;
  height: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;

}

.gallpop{
    position: fixed;
    width: 80%;
    height: 90%;
    z-index: 100;
    background: rgb(27, 27, 27);
}

</style>


